import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { FaqSectionService } from '../faq-section.service';
import { FaqSection } from '../faq-section';

@Component({
    selector: 'app-faq-section',
    templateUrl: './faq-section.component.html',
    styleUrls: ['./faq-section.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class FaqSectionComponent implements OnInit {
	faqCategoryId: any;

	constructor(
		private primengConfig: PrimeNGConfig,
		private faqSectionService: FaqSectionService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.faqSection = data.faqSection,
			this.faqCategoryId = data.faqCategoryId
			this.statuses = faqSectionService.statuses;
	}

	@Input() faqSection: FaqSection;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	faqSectionId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'faqSectionId': [],
		'name': [
			{ type: 'required', message: 'Required' }],
		description: [],
		displayOrder: [],
		enabled: [],
		opsNotes: [],
		introDesc: [],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole faqSection object
		if (this.faqSection) {
			this.faqSectionId = this.faqSection.faqSectionId;
			this.fixDates();
			this.form1.patchValue(this.faqSection);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.faqSectionId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.faqSectionService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.faqSection = res.data.faqSection;
						this.faqSectionId = this.faqSection.faqSectionId;
						this.doAdd.emit(this.faqSection);
					},
					(err: any) => {
						console.log('faqSection-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('faqSection: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.faqSectionService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.faqSection = res.data.faqSection;
						this.doUpdate.emit(this.faqSection);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.faqSectionService.delete(this.faqSection.faqSectionId)
				.subscribe(
					(res: any) => {
						console.log('faqSection-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.faqSection);
					},
					(err: any) => {
						console.log('faqSection-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			faqSectionId: [this.faqSectionId],
			faqCategoryId: [this.faqCategoryId],
			name: ['', Validators.required],
			displayOrder: [],
			enabled: [true],
			description: [],
			opsNotes: [],
			introDesc: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.faqSection.faqSectionDate = moment(this.faqSection.faqSectionDate).toDate();
	}
}
